import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ImageList = () => {
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [select, setSelect] = useState(0);
  const [tab, setTab] = useState(1);
  const [searchTerm, setSearchTerm] = useState(''); // 검색어
  const [searchOption, setSearchOption] = useState('제목'); // 검색조건(초기값:메뉴)
  const [menuData, setMenuData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지(검색용)
  const [totalPages, setTotalPages] = useState(1); // 전체 페이지 수
  const [totalItems, setTotalItems] = useState(0); // 총 게시글 수
  const navigate = useNavigate();
  const pageSize = 9; // 페이지당 항목 수
  const [cate, setCate] = useState('archive'); // 카테고리 상태 추가

  // 제목 상태
  const [title, setTitle] = useState('');

  // cate -> 한글 제목 매핑
  useEffect(() => {
    if (!cate) return;

    switch (cate) {
      case 'notice':
        setTitle('공지사항');
        break;
      case 'business':
        setTitle('사업공고');
        break;
      case 'education':
        setTitle('교육공고');
        break;
      case 'employment':
        setTitle('채용공고');
        break;
      case 'bid':
        setTitle('입찰공고');
        break;
      case 'news':
        setTitle('보도자료');
        break;
      case 'reference':
        setTitle('자료실');
        break;
      case 'archive':
      default:
        setTitle('융합원 아카이브');
        break;
    }
  }, [cate]);

  function formatDate(isoString) {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    getBoard(page, pageSize);
  }, [page, pageSize]);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  // 총 페이지 수(텍스트/페이징 공용)
  const totalPageCount = totalPages || (totalItems ? Math.ceil(totalItems / pageSize) : 1);

  const getBoard = (page, pageSize) => {
    axios
      .get(`https://ciuc.or.kr:8443/api/get/board_list?cate=archive&page=${page}&pageSize=${pageSize}`)
      .then((response) => {
        setMenuData(response.data.data);
        setTotalPages(response.data.totalPages || 1);
        setTotalItems(
          response.data.totalCount !== undefined
            ? response.data.totalCount
            : response.data.totalItems !== undefined
            ? response.data.totalItems
            : 0
        );
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  const handlePage = (num) => {
    setPage(num);
  };

  const handleTab = (num) => {
    setTab(num);
  };

  /**************************************************************/
  // 검색
  /**************************************************************/
  const handleSearch = useCallback(async () => {
    try {
      const url = `https://ciuc.or.kr:8443/api/get/board_search?page=${currentPage}&searchTerm=${searchTerm}&searchOption=${searchOption}&pageSize=${pageSize}&category=${cate}`;
      console.log(url);
      const res = await axios.get(url);
      const { totalItems: searchTotalItems, results } = res.data;

      const searchTotalPages = Math.ceil(searchTotalItems / pageSize);

      setTotalPages(searchTotalPages);
      setTotalItems(searchTotalItems);
      setMenuData(results);
      setCurrentPage(1);
      setPage(1);
    } catch (error) {
      console.error('검색 결과 가져오기 오류:', error);
    }
  }, [searchTerm, searchOption, currentPage, pageSize, cate]);

  /**************************************************************/
  // 검색어 초기화
  /**************************************************************/
  const handleReset = useCallback(() => {
    setSearchTerm('');
    setSearchOption('제목');
    setCurrentPage(1);
    setPage(1);
    getBoard(1, pageSize);
  }, []);

  /**************************************************************/

  const hitCount = async (idx) => {
    try {
      await axios.post(`https://ciuc.or.kr:8443/api/post/board/hit_count/${idx}`);
    } catch (err) {
      console.log(err);
    }
  };

  const handleRowClick = (idx) => {
    const selectedItem = menuData.find((item) => item.idx === idx);
    if (selectedItem) {
      hitCount(idx);
      navigate(`/board/archive/${idx}`, { state: { menuData: selectedItem } });
    }
  };

  const moveBoard = (cate) => {
    setCate(cate);
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const handleWrite = () => {
    navigate(`/board/archive/write`);
  };

  // 페이징 (5개까지만 + « ‹ › »)
  const renderPagination = () => {
    const total = totalPages || 1;
    if (total <= 1) return null;

    const maxVisible = 5;
    let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
    let endPage = startPage + maxVisible - 1;

    if (endPage > total) {
      endPage = total;
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    const goToPage = (target) => {
      if (target < 1 || target > total || target === page) return;
      setPage(target);
    };

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          type="button"
          className={`page_btn page_btn--number ${i === page ? 'is-active' : ''}`}
          onClick={() => goToPage(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <>
        {/* 맨 앞으로 */}
        <button
          type="button"
          className={`page_btn page_btn--arrow ${page === 1 ? 'is-disabled' : ''}`}
          onClick={() => goToPage(1)}
        >
          «
        </button>

        {/* 이전 */}
        <button
          type="button"
          className={`page_btn page_btn--arrow ${page === 1 ? 'is-disabled' : ''}`}
          onClick={() => goToPage(page - 1)}
        >
          ‹
        </button>

        {pageNumbers}

        {/* 다음 */}
        <button
          type="button"
          className={`page_btn page_btn--arrow ${page === total ? 'is-disabled' : ''}`}
          onClick={() => goToPage(page + 1)}
        >
          ›
        </button>

        {/* 맨 끝으로 */}
        <button
          type="button"
          className={`page_btn page_btn--arrow ${page === total ? 'is-disabled' : ''}`}
          onClick={() => goToPage(total)}
        >
          »
        </button>
      </>
    );
  };

  // NEW 표시 여부
  const isNew = (dateString) => {
    const today = new Date();
    const date = new Date(dateString);
    const diffTime = Math.abs(date - today);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 7;
  };

  return (
    <div className="sub_wrap archive">
      <div className="sub_back">
        {/* 상단 배너 */}
        <div className="sub_banner_area notice">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}알림 및 소식{' > '}융합원 아카이브
            </div>
            <div className="banner_main_text">융합원 아카이브</div>
          </div>
        </div>

        {/* 상단 내비 (드롭다운) */}
        <div className="navi_area">
          <div className="navi_back_wrap">
            <div className="navi_back">
              <div className="navi_box" onClick={() => handleSelect(1)}>
                <div className="navi_main_text">알림 및 소식</div>
                <div className="navi_arrow"></div>
                <div className={`navi_select_box ${select === 1 && 'active'}`}>
                  <div className="select_row" onClick={() => moveBoard('notice')}>
                    알림 및 소식
                  </div>
                  <div className="select_row" onClick={() => movePage('/empty')}>
                    사업분야
                  </div>
                  <div className="select_row" onClick={() => movePage('/company')}>
                    기업연구동
                  </div>
                  <div className="select_row" onClick={() => movePage('/empty')}>
                    보유시설
                  </div>
                  <div className="select_row" onClick={() => movePage('/intro')}>
                    융합원소개
                  </div>
                </div>
              </div>
              <div className="navi_box" onClick={() => handleSelect(2)}>
                <div className="navi_main_text">융합원 아카이브</div>
                <div className="navi_arrow"></div>
                <div className={`navi_select_box ${select === 2 && 'active'}`}>
                  <div className="select_row" onClick={() => moveBoard('notice')}>
                    공지사항
                  </div>
                  <div className="select_row" onClick={() => moveBoard('business')}>
                    사업공고
                  </div>
                  <div className="select_row" onClick={() => moveBoard('education')}>
                    교육공고
                  </div>
                  <div className="select_row" onClick={() => moveBoard('employment')}>
                    채용공고
                  </div>
                  <div className="select_row" onClick={() => moveBoard('bid')}>
                    입찰공고
                  </div>
                  <div className="select_row" onClick={() => moveBoard('news')}>
                    보도자료
                  </div>
                  <div className="select_row" onClick={() => moveBoard('reference')}>
                    자료실
                  </div>
                  <div className="select_row" onClick={() => moveBoard('archive')}>
                    융합원 아카이브
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메인 컨텐츠 */}
        <div className="sub_main_area archive">
          {/* 고정 사이드바 */}
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">알림 및 소식</div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/board/notice')}`} onClick={() => moveBoard('notice')}>
                <span>공지사항</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/business')}`} onClick={() => moveBoard('business')}>
                <span>사업공고</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/education')}`} onClick={() => moveBoard('education')}>
                <span>교육공고</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/employment')}`}
                onClick={() => moveBoard('employment')}
              >
                <span>채용공고</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/bid')}`} onClick={() => moveBoard('bid')}>
                <span>입찰공고</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/news')}`} onClick={() => moveBoard('news')}>
                <span>보도자료</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/reference')}`} onClick={() => moveBoard('reference')}>
                <span>자료실</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/archive')}`} onClick={() => moveBoard('archive')}>
                <span>융합원 아카이브</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          <div className="board_container-sub">
            {/* 제목 + 현재 경로 */}
            <div className="board_path_box">
              <div className="path_title">{title}</div>
              <div className="path_navi">
                <span className="home_icon_small">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                    <path d="M4 11.5L12 4l8 7.5V20a1 1 0 0 1-1 1h-5v-5h-4v5H5a1 1 0 0 1-1-1v-8.5z" fill="#999999" />
                    <path
                      d="M2.5 12L12 3l9.5 9"
                      fill="none"
                      stroke="#cccccc"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="path_arrow">&gt;</span>
                <span>알림 및 소식</span>
                <span className="path_arrow">&gt;</span>
                <span className="current">{title}</span>
              </div>
            </div>

            <div className="board_container archive">
              <div className="list_area archive">
                {/* 상단 : 총 게시글 수 + 검색 */}
                <div className="list_top">
                  <div className="board_info">
                    <div className="board_total_count">
                      총 <span className="count">{totalItems}</span>건
                      <span className="page_info">
                        {' '}
                        ({page} / {totalPageCount} 페이지)
                      </span>
                    </div>
                  </div>

                  <div className="search_box">
                    <select value={searchOption} onChange={(e) => setSearchOption(e.target.value)}>
                      <option>제목</option>
                      <option>내용</option>
                      <option>작성자</option>
                    </select>
                    <div className="search_input_wrap">
                      <span className="search_icon" />
                      <input
                        className="search_input"
                        placeholder="검색어를 입력하세요"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                    <div className="option-box">
                      <button type="button" className="search_btn" onClick={handleSearch}>
                        검색
                      </button>
                      <button type="button" className="reset-btn" onClick={handleReset}>
                        초기화
                      </button>
                    </div>
                  </div>
                </div>

                {/* 이미지 카드 리스트 */}
                <div className="list_box image archive">
                  <div className="img_table">
                    {menuData.length === 0 ? (
                      <div className="no_data_message">
                        <div className="no_data_icon">🔍</div>
                        <div className="no_data_title">데이터가 존재하지 않습니다.</div>
                        <div className="no_data_desc">
                          검색 조건을 다시 확인하거나 ‘초기화’ 버튼을 눌러 전체 목록을 확인해 주세요.
                        </div>
                      </div>
                    ) : (
                      menuData.map((item, index) => (
                        <div className="img_row" key={index} onClick={() => handleRowClick(item.idx)}>
                          <div
                            className="img_box"
                            style={{
                              backgroundImage: `url(https://ciuc.or.kr:8443/uploads/${item.img1})`,
                            }}
                          ></div>
                          <div className="img_text_box">
                            {isNew(item.date) ? <div className="new_icon">NEW</div> : <div className="no_icon"></div>}

                            <div className="img_title">{item.title}</div>
                            <div className="img_text">
                              {item.content
                                ? item.content
                                    .replace(/<\/?[^>]+(>|$)/g, '')
                                    .replace(/&nbsp;/g, ' ')
                                    .replace(/&lt;/g, '<')
                                    .replace(/&gt;/g, '>')
                                    .replace(/&amp;/g, '&')
                                : 'No content available'}
                            </div>
                            <div className="img_bottom_box">
                              <div className="bottom_row">{item.writer}</div>
                              <div className="bottom_row">{formatDate(item.date)}</div>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>

                <div className="pagination_box">{renderPagination()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageList;
